/* app/ui/map/map.interactive */

define(
	'app/ui/map/map.interactive',[
		'jquery',
		'pubsub'
	],
	function($) {
		//
		
	}
);
